import {useCallback, useState} from 'react';

export const useIsOverflowing = () => {
  const [isOverflowing, setIsOverflowing] = useState(false);
  // Based on https://stackoverflow.com/a/9333529
  const isOverflowingMeasurer = useCallback((ref: HTMLDivElement) => {
    if (!ref) {
      setIsOverflowing(false);
      return;
    }
    const contentIsBiggerThanContainer = ref.scrollHeight > ref.clientHeight;

    setIsOverflowing(contentIsBiggerThanContainer);
    return;
  }, []);

  return { isOverflowing, isOverflowingMeasurer };
};
